/* SIDONIA · Seguir a dueños que anuncian.
 * Cualquier botón con data-sidonia-follow (data-slug, data-name, data-tipo, data-url) guarda o quita al dueño en este
 * navegador; «Mi perfil» (sections/sidonia-profile.liquid) los enseña. Como los favoritos (assets/sidonia-card.js).
 */
(() => {
  if (window.sidoniaFollow) return;
  const KEY = 'sidonia:siguiendo';
  const EVENT = 'sidonia:siguiendo';

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list.filter((d) => d && d.slug) : [];
    } catch (e) {
      return [];
    }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* navegación privada */ }
    document.dispatchEvent(new CustomEvent(EVENT));
  };
  const has = (slug) => read().some((d) => d.slug === slug);

  const toggle = (data) => {
    const list = read();
    if (list.some((d) => d.slug === data.slug)) write(list.filter((d) => d.slug !== data.slug));
    else write([{ ...data, desde: Date.now() }, ...list]);
  };

  const sync = () => {
    document.querySelectorAll('[data-sidonia-follow]').forEach((b) => {
      const on = has(b.dataset.slug);
      b.setAttribute('aria-pressed', String(on));
      const label = b.querySelector('[data-follow-label]');
      if (label) label.textContent = on ? 'Siguiendo' : 'Seguir';
    });
  };

  document.addEventListener('click', (event) => {
    const b = event.target.closest('[data-sidonia-follow]');
    if (!b || !b.dataset.slug) return;
    event.preventDefault();
    toggle({ slug: b.dataset.slug, name: b.dataset.name || '', tipo: b.dataset.tipo || 'particular', url: b.dataset.url || '' });
  });
  document.addEventListener(EVENT, sync);
  window.addEventListener('storage', (event) => { if (event.key === KEY) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  window.sidoniaFollow = { read, toggle, has, EVENT };
})();
